<template>
  <v-menu bottom max-width="600" nudge-bottom="20" nudge-right="35" :open-on-click="false" :close-on-click="false" :close-on-content-click="false" content-class="tour-arrow tour-arrow-left purple white--text pt-6 px-4" transition="slide-y-transition" :value="show">
    <template v-slot:activator="{ on }">
      <slot name="breadcrumbs" v-on="on"/>
    </template>

    <v-card color="purple white--text">
      <div class="mb-4">
        <slot name="top"/>
      </div>
      <div ref="video" v-if="video">
        <iframe width="560" height="315" :src="'https://www.youtube.com/embed/'+video+'?enablejsapi=1&modestbranding=1'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="mt-4">
        <slot name="bottom"/>
      </div>
      <v-card-actions>
        <v-checkbox v-model="doNotShowAgain">
          <template v-slot:label><span class="grey--text text--lighten-1">Do not show again</span></template>
        </v-checkbox>
        <v-spacer/>
        <v-btn plain @click="close()" color="white" small>Dismiss</v-btn>
        <slot name="actions" :close="close"/>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'PopupHint',
	props: {
    hint: {type:String,require:true}
  },
  data() {
    return {
      show: false,
      doNotShowAgain: false,
      video: ''
    }
  },
  computed: {
    userSettings() {
      return this.$store.getters.userSettings;
    }
  },
  async created() {
    if (!this.userSettings[this.hint] && !this.$store.state.user.admin) {
      const results = await this.$apiCall(`query PopupHint($key:String!) {
                                             video(key:$key)
                                           }`,
                                          {key:this.hint});
      if (!results.error)
        this.video = results.data.video;
      this.show = true;
    }
  },
  methods: {
    close() {
      const iframe = this.$refs.video?.getElementsByTagName("iframe")[0]?.contentWindow;
      iframe?.postMessage(JSON.stringify({ event: "command", func: "stopVideo", args:"" }), '*');

      if (this.doNotShowAgain) {
        this.userSettings[this.hint] = 1;
        this.$store.commit('setUserSettings', this.userSettings);
      }

      this.show = false;
    }
  }
}
</script>